$(document).ready(function () {
    const cacheKey = 'mapaData';
    const stored = sessionStorage.getItem(cacheKey);
    if (stored) {
        const data = JSON.parse(stored);
        if ($('#map').length) {
            renderMap(data);
        }
    } else {
        $.ajax({
            url: 'https://php.shopcode.cz/api/vykrajovatka/api-mapa.php',
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                sessionStorage.setItem(cacheKey, JSON.stringify(data));
                if ($('#map').length) {
                    renderMap(data);
                }
            },
            error: function () {
                console.error('❌ Nepodařilo se načíst data z mapy');
            }
        });
    }
});

function renderMap(data) {
    const map = L.map('map').setView([50.087, 14.42], 14);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; OpenStreetMap',
        maxZoom: 18
    }).addTo(map);
    const defaultIcon = L.icon({
        iconUrl: '/user/documents/upload/sablona/point.svg',
        iconSize: [26, 30],
        iconAnchor: [13, 30]
    });
    const allLatLngs = [];
    data.forEach(point => {
        const latLng = [point.latitude, point.longitude];
        allLatLngs.push(latLng);
        const rightPanelContent = `
                <div class="title">
                ${point.nazev}<span class="closePointMap"></span></div>
                <div class="upper">
                 <div class="address"><p>${point.full_address}</p></div>
                ${point.oteviraci_doba ? `<div class="openHours"><p>${point.oteviraci_doba.replace(/\n/g, '<br>')}</p></div>` : ''}
                </div>
                <div class="bottom">
                
                <div><a href="${point.odkaz_na_mapu}" target="_blank" >Zobrazit v mapách</a></div>
        `;

        const marker = L.marker(latLng, { icon: defaultIcon }).addTo(map);
        marker.on('click', function () { 
            $('.rightMap #popupmap').html('');
            $('.rightMap #popupmap').append(rightPanelContent).addClass('open');
            $('.rightMap').addClass('openPopup');
        });

        point._marker = marker;
    });

    // Zavření popupu při kliknutí mimo
    $(document).on('click', function(event) {
        if (!$(event.target).closest('#popupmap, .leaflet-marker-icon').length) {
            $('#popupmap').removeClass('open');
            $('.rightMap').removeClass('openPopup');
        }
    });
    // Zavření popupu při kliknutí na close Button
    $(document).on('click', '.closePointMap', function(event) {
            $('#popupmap').removeClass('open');
            $('.rightMap').removeClass('openPopup');
    });


    if (allLatLngs.length > 0) {
        map.fitBounds(L.latLngBounds(allLatLngs), { padding: [20, 20] });
    }
    window._leafletMap = map;
    window._leafletPoints = data;
}
